/**
 * Parses the parent gRPC entity name from a child entity name.
 * gRPC names follow the format `...[grandparent/{id}/][parent/{id}/]child/{id}`.
 * This function extracts the parent entity name from the given child entity name.
 *
 * @param childName - The full gRPC name of the child entity.
 * @returns The gRPC name of the parent entity.
 */
export function parseParentName(childName) {
    return childName.split('/').slice(0, -2).join('/');
}
